import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";
import { legalServiceSchema } from "@/components/seo/json-ld";

export const Route = createFileRoute("/aree/diritto-penale")({
  head: () => seoMeta({
    title: "AI per il diritto penale",
    description: "Ricerca su Cassazione penale, analisi capi d'imputazione, redazione di memorie e ricorsi. AI specializzata per il penalista.",
    path: "/aree/diritto-penale",
  }),
  component: () => (
    <ContentPage
      extraSchemas={[legalServiceSchema({ name: "LexAIPro - AI per il diritto penale", description: "Ricerca giurisprudenziale, analisi atti e redazione memorie per il penalista.", path: "/aree/diritto-penale" })]}
      eyebrow="Aree di pratica"
      title="LexAIPro per il diritto penale"
      lead="Strumenti AI per la difesa penale: ricerca su Cassazione penale, analisi atti del PM, redazione di memorie difensive, ricorsi e istanze."
      breadcrumbs={[{name:"Home",path:"/"},{name:"Aree",path:"/aree/diritto-penale"},{name:"Diritto penale",path:"/aree/diritto-penale"}]}
      sections={[
        { heading: "Casi d'uso", bullets: ["Memorie difensive e arringhe","Ricorsi in Cassazione","Analisi capi d'imputazione","Ricerca su precedenti analoghi","Riti alternativi e patteggiamento"] },
      ]}
      cta={{ label: "Prova gratis", to: "/signup" }}
      heroImage={pickContent(13)}
      updated="2026"
    />
  ),
});
